export enum i18nNamespaceEnum {
  mandatary = "mandatary",
  contractor = "contractor",
}
